export default __webpack_public_path__ + "static/media/arrow_upward.29d89fd8.svg";